export default __webpack_public_path__ + "static/media/abouthomeimage.7caa49e8.png";